import { SessionService } from './SessionService';

const API_URL = process.env.REACT_APP_API_URL;

const getAllRuns = async (skip, limit, sort, order, q) => {
  try {
    const params = new URLSearchParams();
    if (skip) params.append('skip', skip);
    if (limit) params.append('limit', limit);
    if (sort) params.append('sort', sort);
    if (order) params.append('order', order);
    if (q) params.append('q', q);

    const response = await fetch(`${API_URL}/admin/runs?${new URLSearchParams(params)}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${await SessionService.getSessionFromStorage()}`,
      },
    });
    return await response.json();
  } catch (error) {
    console.log('🚀 ~ file: RunsService.js ~ error', error);
    return { status: 500 };
  }
};

const getRun = async id => {
  try {
    const response = await fetch(`${API_URL}/admin/runs/${id}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${await SessionService.getSessionFromStorage()}`,
      },
    });
    return await response.json();
  } catch (error) {
    console.log('🚀 ~ file: RunsService.js ~ error', error);
    return { status: 500 };
  }
};

const updateRun = async (id, data) => {
  try {
    const response = await fetch(`${API_URL}/admin/runs/${id}`, {
      method: 'PATCH',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${await SessionService.getSessionFromStorage()}`,
      },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    console.log('🚀 ~ file: RunsService.js ~ error', error);
    return { status: 500 };
  }
};

const deleteRun = async id => {
  try {
    const response = await fetch(`${API_URL}/admin/runs/${id}`, {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${await SessionService.getSessionFromStorage()}`,
      },
    });
    return await response.json();
  } catch (error) {
    console.log('🚀 ~ file: RunsService.js ~ error', error);
    return { status: 500 };
  }
};

export const RunsService = {
  getAllRuns,
  getRun,
  updateRun,
  deleteRun,
};
